export default __webpack_public_path__ + "static/media/Ballroll_00372.a98578e7.png";